"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DishUpdateSchema = exports.DishUpdateScalarSchema = exports.DishCreateSchema = exports.DishCreateScalarSchema = exports.DishPrismaUpdateSchema = exports.DishPrismaCreateSchema = exports.DishSchema = exports.DishScalarSchema = void 0;
// @ts-nocheck
const zod_1 = require("zod");
const baseSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    imageBucketPath: zod_1.z.string(),
    nameEN: zod_1.z.string().min(1, { message: "Name must be between 3 and 100 characters" }).max(100, { message: "Name must be between 3 and 100 characters" }),
    nameFR: zod_1.z.string().min(1, { message: "Name must be between 3 and 100 characters" }).max(100, { message: "Name must be between 3 and 100 characters" }),
    descriptionEN: zod_1.z.string().max(1000, { message: "Description must be between 0 and 1000 characters" }).nullish(),
    descriptionFR: zod_1.z.string().max(1000, { message: "Description must be between 0 and 1000 characters" }).nullish(),
    priceCents: zod_1.z.number(),
    discount: zod_1.z.number().gte(0, { message: "Discount must be greater than 0" }).lte(100, { message: "Discount must be less than 100" }).default(0),
    isGlobalDiscount: zod_1.z.boolean().default(true),
    order: zod_1.z.number().default(0),
    couponDiscount: zod_1.z.number().gte(0, { message: "Discount must be greater than 0" }).lte(100, { message: "Discount must be less than 100" }).default(0).nullish(),
    createdAt: zod_1.z.coerce.date().default(() => new Date()),
    updatedAt: zod_1.z.coerce.date().default(() => new Date()),
}).strict();
const relationSchema = zod_1.z.object({
    category: zod_1.z.record(zod_1.z.unknown()),
});
const fkSchema = zod_1.z.object({
    categoryId: zod_1.z.string().uuid(),
});
/**
 * `Dish` schema excluding foreign keys and relations.
 */
exports.DishScalarSchema = baseSchema;
/**
 * `Dish` schema including all fields (scalar, foreign key, and relations) and validations.
 */
exports.DishSchema = exports.DishScalarSchema.merge(fkSchema).merge(relationSchema.partial());
/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
exports.DishPrismaCreateSchema = baseSchema.partial().passthrough();
/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
exports.DishPrismaUpdateSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    imageBucketPath: zod_1.z.string(),
    nameEN: zod_1.z.string().min(1, { message: "Name must be between 3 and 100 characters" }).max(100, { message: "Name must be between 3 and 100 characters" }),
    nameFR: zod_1.z.string().min(1, { message: "Name must be between 3 and 100 characters" }).max(100, { message: "Name must be between 3 and 100 characters" }),
    descriptionEN: zod_1.z.string().max(1000, { message: "Description must be between 0 and 1000 characters" }).nullish(),
    descriptionFR: zod_1.z.string().max(1000, { message: "Description must be between 0 and 1000 characters" }).nullish(),
    priceCents: zod_1.z.union([zod_1.z.number(), zod_1.z.record(zod_1.z.unknown())]),
    discount: zod_1.z.union([zod_1.z.number().gte(0, { message: "Discount must be greater than 0" }).lte(100, { message: "Discount must be less than 100" }).default(0), zod_1.z.record(zod_1.z.unknown())]),
    isGlobalDiscount: zod_1.z.boolean().default(true),
    order: zod_1.z.union([zod_1.z.number().default(0), zod_1.z.record(zod_1.z.unknown())]),
    couponDiscount: zod_1.z.union([zod_1.z.number().gte(0, { message: "Discount must be greater than 0" }).lte(100, { message: "Discount must be less than 100" }).default(0).nullish(), zod_1.z.record(zod_1.z.unknown())]),
    createdAt: zod_1.z.coerce.date().default(() => new Date()),
    updatedAt: zod_1.z.coerce.date().default(() => new Date())
}).partial().passthrough();
/**
 * `Dish` schema for create operations excluding foreign keys and relations.
 */
exports.DishCreateScalarSchema = baseSchema.partial({
    discount: true, isGlobalDiscount: true, order: true, couponDiscount: true, createdAt: true, updatedAt: true
});
/**
 * `Dish` schema for create operations including scalar fields, foreign key fields, and validations.
 */
exports.DishCreateSchema = exports.DishCreateScalarSchema.merge(fkSchema);
/**
 * `Dish` schema for update operations excluding foreign keys and relations.
 */
exports.DishUpdateScalarSchema = baseSchema.partial();
/**
 * `Dish` schema for update operations including scalar fields, foreign key fields, and validations.
 */
exports.DishUpdateSchema = exports.DishUpdateScalarSchema.merge(fkSchema.partial());
